let checkingFetches = [];
// TODO: is this function doing anything?
export function getCheckingFetches() {
    return checkingFetches;
}
export function addCheckingFetch(item) {
    return checkingFetches.push(item);
}
export function resetFetches() {
    checkingFetches = [];
}
